export * as SimpleWidget from './simple'
